import { render, staticRenderFns } from "./CaseLabMedia.vue?vue&type=template&id=56a2fae6&scoped=true&"
import script from "./CaseLabMedia.vue?vue&type=script&lang=js&"
export * from "./CaseLabMedia.vue?vue&type=script&lang=js&"
import style0 from "./CaseLabMedia.vue?vue&type=style&index=0&id=56a2fae6&scoped=true&lang=css&"
import style1 from "./CaseLabMedia.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a2fae6",
  null
  
)

export default component.exports